module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }],
    attrs: {
      "id": "video"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "nav-container"
  }, [_c('div', {
    class: {
      nav: true,
      fixed: _vm.isFixed
    }
  }, [_c('ul', {
    staticClass: "tutorial-list"
  }, [_vm._l((_vm.tutorialList), function(item, index) {
    return [(item.id === 3) ? _c('li', {
      key: index,
      class: {
        tutorial: true,
        active: _vm.activeName === item.name
      }
    }) : _c('li', {
      key: index,
      class: {
        tutorial: true,
        active: _vm.activeName === item.name
      },
      on: {
        "click": function($event) {
          return _vm.updateActiveTab(item.name)
        }
      }
    }, [_c('span', {
      staticClass: "tutorial-name"
    }, [_vm._v(_vm._s(item.name))])])]
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, _vm._l((_vm.activeTabList.children), function(tutorial, tutorialIndex) {
    return _c('div', {
      key: tutorialIndex,
      staticClass: "tutorial-list",
      style: ({
        'background-color': tutorialIndex % 2 === 0 ? '#f5f7fa' : '#ffffff'
      })
    }, [_c('div', {
      staticClass: "tutorial"
    }, [_c('p', {
      staticClass: "tutorial-label"
    }, [_vm._v(_vm._s(tutorial.name))]), _vm._v(" "), _c('p', {
      staticClass: "tutorial-title"
    }, [_vm._v(_vm._s(tutorial.desc))]), _vm._v(" "), _c('ul', {
      class: _vm.matchStyle(tutorial.name).style
    }, _vm._l((tutorial.children), function(videoItem, videoIndex) {
      return _c('li', {
        key: videoIndex,
        staticClass: "video",
        on: {
          "click": function($event) {
            return _vm.openVideo(videoItem.url, videoItem.extra_info.is_play)
          }
        }
      }, [_c('div', {
        staticClass: "cover"
      }), _vm._v(" "), _c('div', {
        staticClass: "video-tag"
      }, [_vm._v(_vm._s(videoItem.extra_info.tag))]), _vm._v(" "), _c('div', {
        staticClass: "img",
        style: ({
          background: ("url('" + (videoItem.resource) + "') center/cover")
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "name",
        attrs: {
          "title": videoItem.name
        }
      }, [_vm._v(_vm._s(videoItem.name))]), _vm._v(" "), _c('div', {
        staticClass: "video-right"
      }, [_c('div', {
        staticClass: "name",
        attrs: {
          "title": videoItem.name
        }
      }, [_c('span', [_vm._v(_vm._s(videoItem.name))])]), _vm._v(" "), _c('div', {
        staticClass: "tag-time"
      }, [(_vm.matchStyle(tutorial.name).isTag) ? _c('span', {
        class: ['tag', videoItem.extra_info.level === '新手' ? '' : 'advanced']
      }, [_vm._v(_vm._s(videoItem.extra_info.level))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "icon-time-2 icon",
        staticStyle: {
          "color": "#C4C6CC"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v(_vm._s(videoItem.extra_info.duration || '-- : --'))])])]), _vm._v(" "), (videoItem.children.length !== 0) ? _c('ul', {
        staticClass: "video-item"
      }, _vm._l((videoItem.children), function(item, index) {
        return _c('li', {
          key: index,
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openVideo(item.url, item.extra_info.is_play)
            }
          }
        }, [_c('span', {
          staticClass: "icon-bofang",
          staticStyle: {
            "font-size": "24px",
            "color": "#979ba5",
            "margin-right": "16px"
          }
        }), _vm._v(" "), _c('span', {
          attrs: {
            "title": item.name
          }
        }, [_vm._v(_vm._s(item.name))])])
      }), 0) : _vm._e()])
    }), 0)])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showVideo,
      "center": "",
      "close-on-click-modal": false,
      "destroy-on-close": true,
      "custom-class": "pro-video-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showVideo = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "src": _vm.videoUrl,
      "autoplay": "",
      "controls": ""
    }
  }, [_vm._v("\n            抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 "), _c('a', {
    attrs: {
      "href": _vm.videoUrl
    }
  }, [_vm._v("下载")]), _vm._v("\n            并用你喜欢的播放器观看!\n        ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-container"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("视频教程")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("深入浅出，带您了解蓝鲸产品")]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/video/video.png"),
      "alt": "video"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4825ae1c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/index.vue
// module id = YPp1
// module chunks = 15